export enum ReportType {
    PDF,
    CSV,
    Default
}
